@if(!loading) {
  <div class="project-create-cont">
    <awc-input
      [value]="title"
      [label]="instanceTitle + ' Name'"
      [placeholder]="'Enter a name for your new ' + instanceTitle"
      (valueChange)="title = $event.toString()"
    ></awc-input>
    <awc-input
      [value]="file?.name || ''"
      [label]="'File'"
      [iconButton]="{ icon: Icons.ADD_GEOMETRY }"
      [placeholder]="'File Name'"
      [readOnly]="true"
      (valueChange)="title = $event.toString()"
      (iconButtonAction)="onUploadClicked()"
    ></awc-input>
    <awc-textarea
      [value]="description"
      [label]="instanceTitle + ' Description'"
      [placeholder]="'Add Description'"
      [lines]="5"
      (changes)="description = $event"></awc-textarea>

    <awc-button
      [text]="'Create'"
      [type]="ButtonType.SECONDARY"
      [size]="ButtonSize.MEDIUM"
      [awcSizing]="ComponentWidth.FILL"
      [disabled]="!file || !title"
      (buttonClicked)="onCreateDesign()"></awc-button>
  </div>

  <input #fileUpload hidden type="file" accept=".json" (change)="onFileSelected($event)">
} @else {
  <div class="project-create-cont">
    <awc-icon [icon]="Icons.SPINNER"></awc-icon>
  </div>
}
